import { createContext, useContext } from "react";

export interface ShellChrome {
  // Register a mobile app-bar back handler (null clears it).
  setBack: (handler: (() => void) | null) => void;
  // Hide the whole shell (nav, breadcrumb, footer) for full-window views.
  setHidden: (hidden: boolean) => void;
}

export const ShellChromeContext = createContext<ShellChrome>({
  setBack: () => {},
  setHidden: () => {},
});

export function useShellChrome(): ShellChrome {
  return useContext(ShellChromeContext);
}
